<template>
  <SearchMap/>
</template>
<script>
import SearchMap from 'place/map/searchMap.vue'
export default {
    components:{
      SearchMap
    }
}
</script>